// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Especialidades_containerPrincipal__qWKoP","divEspecialidades":"Especialidades_divEspecialidades__JRbSY"};